<div [formGroup]="form" style="width: 100%;margin-top:10px;margin-bottom:10px">
    <mat-form-field appearance="fill" class="example-full-width mask" *ngIf="property.renderType === RenderType.TextBox"
        style="width:100%" [ngStyle]="{'opacity': (property.disabled) ? '0.5' : '1'}">
        <mat-label>{{property.displayName}}</mat-label>
        <input *ngIf="property.renderType === RenderType.TextBox && property.inputType === InputType.Text"
            autocomplete="off" [readonly]="property.disabled" [attr.disabled]="property.disabled ? '' : null"
            [formControlName]="property.propertyName" (change)="textBoxUpdate($event)" type="text" matInput
            [errorStateMatcher]="matcher" [placeholder]="property.displayName" />

        <input *ngIf="property.renderType === RenderType.TextBox && property.inputType === InputType.Number"
            autocomplete="off" [readonly]="property.disabled" [attr.disabled]="property.disabled ? '' : null"
            [formControlName]="property.propertyName" (change)="textBoxUpdate($event)" type="number" matInput
            [errorStateMatcher]="matcher" [placeholder]="property.displayName" />

        <input *ngIf="property.renderType === RenderType.TextBox && property.inputType === InputType.Password"
            autocomplete="off" [readonly]="property.disabled" [attr.disabled]="property.disabled ? '' : null"
            [formControlName]="property.propertyName" (change)="textBoxUpdate($event)" type="password" matInput
            [errorStateMatcher]="matcher" [placeholder]="property.displayName" />


        <mat-error *ngIf="!isValid" style="margin-top:14px;margin-left:-10px;">
            <span *ngIf="Error('required')">{{property.validationErrorMessages ?
                property.validationErrorMessages['required'] : '' }}</span>
            <span *ngIf="Error('pattern')">{{property.validationErrorMessages ?
                property.validationErrorMessages['pattern'] : '' }}</span>
            <span *ngIf="Error('max')">{{property.validationErrorMessages ? property.validationErrorMessages['max'] : ''
                }}</span>
            <span *ngIf="Error('maxlength')">{{property.validationErrorMessages ?
                property.validationErrorMessages['maxlength'] : '' }}</span>

            <span *ngIf="Error('min')">{{property.validationErrorMessages ? property.validationErrorMessages['min'] : ''
                }}</span>
            <span *ngIf="Error('minlength')">{{property.validationErrorMessages ?
                property.validationErrorMessages['minlength'] : '' }}</span>

        </mat-error>
    </mat-form-field>

    <mat-form-field class="mask" *ngIf="property.renderType === RenderType.Dropdown" appearance="fill"
        style="width:100%;">
        <mat-label>{{property.displayName}}</mat-label>
        <mat-select matInput [value]="property.value" [disabled]="property.disabled"
            (selectionChange)="dropdownUpdate($event)">
            <mat-option *ngFor="let k of property.renderTypeValues" [value]="k.value">
                {{k.text}}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-label style="display: block;font: 800 14px/20px Roboto; margin-bottom: 10px;" *ngIf="property.renderType === RenderType.Slider">{{property.displayName}}</mat-label>
    <ngx-slider style="width:80%" *ngIf="property.renderType === RenderType.Slider" style="margin-top:15px;"  [(value)]="property.value" [options]="options"></ngx-slider>

    <mat-checkbox *ngIf="property.renderType === RenderType.Checkbox" matInput color="primary"
        [formControlName]="property.propertyName" (change)="checkBoxUpdate($event)" [value]="property.value">
        <mat-label>{{property.displayName}}</mat-label>
    </mat-checkbox>

    <mat-slide-toggle style="padding:5px;margin-top:10px"
        *ngIf="property.renderType === RenderType.Toggle && property.inputType == InputType.Boolean"
        [checked]="property.value" [disabled]="property.disabled" matInput (change)="toggleUpdate($event)">
        {{property.displayName}}</mat-slide-toggle>

    <mat-slide-toggle style="padding:5px;margin-top:10px"
        *ngIf="property.renderType === RenderType.Toggle && property.inputType == InputType.Number"
        [checked]="property.value == 1" [disabled]="property.disabled" matInput (change)="toggleUpdate($event)">
        {{property.displayName}}</mat-slide-toggle>
</div>